import { ProductsFilterItemType } from "../type";

/** Убирает поля с пустыми массивами и undefined. */
export const clearEmptyFilters = (
  filters: ProductsFilterItemType,
): ProductsFilterItemType =>
  Object.fromEntries(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Object.entries(filters).filter(([_, value]) =>
      Array.isArray(value) ? value.length > 0 : value !== undefined,
    ),
  );

/** Сравнивает наборы фильтров без учёта порядка полей и значений. */
export const isSameFilters = (
  a: ProductsFilterItemType,
  b: ProductsFilterItemType,
): boolean => {
  const left = clearEmptyFilters(a);
  const right = clearEmptyFilters(b);
  const keys = Object.keys(left) as (keyof ProductsFilterItemType)[];

  if (keys.length !== Object.keys(right).length) return false;

  return keys.every((key) => {
    const leftValues = left[key];
    const rightValues = right[key];
    if (!rightValues || leftValues.length !== rightValues.length) return false;
    return leftValues.every((value) => rightValues.includes(value));
  });
};
